<template>
  <v-app>
    <v-app-bar app height="48" color="blue darken-2'" dark>
      <div class="d-flex align-center">
        <v-img src="@/assets/still-small.png" height="30" width="20" contain/>
        <div class="text-h6 ml-3 mt-1">PURTRAK</div>
      </div>
      <v-spacer/>
      <v-btn text @click="$auth.logout();$store.commit('clearUser');$auth.login()">Sign out</v-btn>
    </v-app-bar>

    <v-main>
      <v-container fluid fill-height>
        <v-row justify="center">
          <v-card width="380" class="d-inline-block text-center pa-1" flat>

            <v-card flat class="text-h5 text-center" v-if="error">
              {{error}}
            </v-card>

          </v-card>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      error: ''
    }
  },
  computed: {
    user() {
      return this.$store.state.user ?? {};
    },
  },
  async created() {
    this.error = this.$route.query.error_message;

    const token = await this.$auth.getTokenSilently();
    if (!token) {
      const sessionState = sessionStorage.getItem('oauthState');
      sessionStorage.removeItem('oauthState');
      if (!this.error && this.$route.query.state !== sessionState)
        this.error = 'State mismatch';
      else {
        await this.$auth.getToken(this.$route.query.code);
        this.$store.commit('setUser', null);
        try {
          await this.$router.replace({path:'/'});
        } catch (error) {
        }
      }
    }
//    this.$router.replace({path:'/'});
  }
}
</script>
